import { AppRouteProps } from "@bsm/component/dist/containers/AppRoutes";
import { TeacherDetailsRoutes } from "./details/TeacherDetailsRoutes";
import { TeacherListRoutes } from "./list/TeacherListRoutes";

export const TeacherViewsRoutes: Array<AppRouteProps> = [
    ...TeacherListRoutes,
    ...TeacherDetailsRoutes
]